import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'entitlements' as const;

export const { reject, resolve, patterns } = createLifecycleFor(TYPE);

export const REFRESH_ENTITLEMENTS = 'REFRESH_ENTITLEMENTS' as const;

export interface RefreshEntitlementsAction {
  type: typeof REFRESH_ENTITLEMENTS;
}

export const refreshEntitlements: RefreshEntitlementsAction = {
  type: REFRESH_ENTITLEMENTS,
};
